<div class="d-none d-sm-none d-md-block ">
  <app-logo-toolbar></app-logo-toolbar>
</div>
<div class="d-block d-sm-block d-md-none">
  <mat-toolbar color="primary" class="shadow mb-1">
    <div class="container-fluid">
      <div class="row">
        <div class="col-1 p-0">
          <span (click)="stepOn()">
            <fa-icon [icon]="faArrowLeft" class="fa-solid"></fa-icon>
          </span>

        </div>
        <div class="col-11 d-flex justify-content-center p-0">
          <span>{{ 'FAILEDPAGE.LABEL1' | translate }}</span>
        </div>
      </div>
    </div>
  </mat-toolbar>

</div>

<app-info-toolbar></app-info-toolbar>

<div class="container-fluid ">
    <div class="row containerRow">
      <div class="col-3 d-none d-sm-none d-md-block">
        <div class="row">
          <div class = "col">
            <app-breadcrumb></app-breadcrumb>
          </div>
        </div>
        <div class="row d-none d-sm-none d-md-block mb-2">
          <div class="col">
            <span class="successTitle">{{ 'FAILEDPAGE.LABEL2' | translate }}</span>
          </div>
        </div>
        <div class="row">
          <div class="d-none d-sm-none d-md-block col-12 col " >
            <app-side-menu ></app-side-menu>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-9">
        <app-failed></app-failed>
      </div>
    </div>
    <app-footer></app-footer>
  
  </div>